import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';
import WebsiteComponent from './components/websiteComponent';

const SupportServicesWebsite = ({ onChange, initialValue, formatMessage }) => (
  <WebsiteComponent
    name="Transfer-Support-Services"
    value={initialValue.value}
    onChange={onChange}
    stylesName="transfer-website-container"
    placeholder={formatMessage(messages.websitePlaceholder)}
    subheading={formatMessage(messages.transferSupportWebsiteLabel)}
    showError={initialValue.showError}
  />
);

SupportServicesWebsite.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};

export default SupportServicesWebsite;
